import { createContext } from "react";
import { getDefaultCountry } from "./config";
import LocaleService, { getDefaultCountryCode } from "./LocaleService";
var CountryContext = createContext({
  get defaultCountryCode() {
    return LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE ? getDefaultCountry() : getDefaultCountryCode() || getDefaultCountry();
  }
});
export var CountryContextProvider = CountryContext.Provider;
export var CountryContextConsumer = CountryContext.Consumer;
export default CountryContext;